import React, { useState, useRef } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import axios from "axios";
import { baseURLV1 } from "../../../service/API.js";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import Switch from "@material-ui/core/Switch";
import { Link } from "react-router-dom";
// import "../../../../component.css";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

export const CreateMasterTCO = () => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const { authToken } = useSelector((state) => state.auth);
  suhbeader.setTitle(intl.formatMessage({ id: "###",defaultMessage:"Create Master TCO" }));
  const history = useHistory();
  const [modelGroup, setModelGroup] = useState();
  const [country, setCountry] = useState();
  const [unit, setUnit] = useState();
  const [exRate, setExRate] = useState();
  const [fuelCost, setFuelCost] = useState();
  const [operLaborCost, setOperLaborCost] = useState(); 
  const [state, setState] = useState(true);

  const AlertError = (message) => {
    Swal.fire("Create Master TCO!", message, "error");
  };
  const handleChangeSwitch = () => {
    setState(!state);
  };

  const handleSend = async (data) => {
    if (modelGroup === undefined || modelGroup === "") {
      return AlertError("Please insert model group !!");
    }
    if (country === undefined || country === "") {
        return AlertError("Please insert country !!");
      }

    if (unit === undefined || unit === "") {
        return AlertError("Please insert unit !!");
    }

    if (exRate === undefined || exRate === "") {
        return AlertError("Please insert ex rate !!");
    }

    if (fuelCost === undefined || fuelCost === "") {
        return AlertError("Please insert fuel cost !!");
    }

    if (operLaborCost === undefined || operLaborCost === "") {
        return AlertError("Please insert operation labor cost !!");
    }
      
    // let get_store_id = localStorage.getItem("store_id");
    
    var events = {
      modelGroup: modelGroup,
      country: country,
      unit: unit,
      exRate: exRate,
      fuelCost: fuelCost,
      operLaborCost: operLaborCost,
      enabled: state,
    };

    let apiUrls = `${baseURLV1}/dynamic/masterTcos`;
    axios({
      method: "post",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      data: events,
    })
      .then(async (res) => {
        Swal.fire("Save !", "Save TCO", "success");
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Created !",
          "Your can not create TCO !! " + err,
          "error"
        );
      });
  };

  return (
    <Card>
      <CardHeader title={intl.formatMessage({ id: "###",defaultMessage:"Create Master TCO" })}></CardHeader>
      <CardBody>
        <div className="container">
          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <p
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            >
              <span style={{ color: "red" }}>
              *
            </span>
              {intl.formatMessage({ id: "###" ,defaultMessage:"Model Group"})}:{" "}
            </p>
            <input
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              onChange={(modelGroup) => setModelGroup(modelGroup.target.value)}
            />
          </div>

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <p
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            >
              <span style={{ color: "red" }}>
              *
            </span>
             {intl.formatMessage({ id: "###",defaultMessage:"Country"})}:{" "}
            </p>
            <input
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              onChange={(country) => setCountry(country.target.value)}
            />
          </div>

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <p
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            >
              <span style={{ color: "red" }}>
              *
            </span>
             {intl.formatMessage({ id: "###",defaultMessage:"Unit"})}:{" "}
            </p>
            <input
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              onChange={(unit) => setUnit(unit.target.value)}
            />
          </div>
          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <p
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            >
              <span style={{ color: "red" }}>
              *
            </span>
             {intl.formatMessage({ id: "###",defaultMessage:"Ex Rate"})}:{" "}
            </p>
            <input
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              onChange={(exRate) => setExRate(exRate.target.value)}
            />
          </div>

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <p
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            >
              <span style={{ color: "red" }}>
              *
            </span>
             {intl.formatMessage({ id: "###",defaultMessage:"Fuel Cost"})}:{" "}
            </p>
            <input
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              onChange={(fuelCost) => setFuelCost(fuelCost.target.value)}
            />
          </div>

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <p
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            >
              <span style={{ color: "red" }}>
              *
            </span>
             {intl.formatMessage({ id: "###",defaultMessage:"Operation Labor Cost"})}:{" "}
            </p>
            <input
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              onChange={(operLaborCost) => setOperLaborCost(operLaborCost.target.value)}
            />
          </div>

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/MasterTCO">
              <button type="button" className="btn btn-secondary wbt">
                {intl.formatMessage({ id: "###",defaultMessage:"Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => handleSend()}>
              {intl.formatMessage({ id: "###" ,defaultMessage:"Save"})}
            </button>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
